/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
// Utils
// import { notifyPaymentRequired } from 'common/utils/customerValidation'

// Styled Elements
import { MenuDetailedWrapper, Header, XStack, YStack, Divider, MenuNavLink } from '../common.elements'

// Map Redux Props
function AiCatalystSidebar() {
  return (
    <MenuDetailedWrapper>
      <YStack style={{ gap: '8px' }}>
        <YStack style={{ gap: '8px', padding: '0 20px' }}>
          <XStack style={{ alignItems: 'center', gap: '12px' }}>
            <YStack>
              <Header>AI Catalyst</Header>
            </YStack>
          </XStack>
        </YStack>
        <XStack style={{ padding: '8px 20px' }}>
          <Divider />
        </XStack>

        <YStack style={{ padding: '0 8px' }}>
          <MenuNavLink to="/ai-catalyst/regulatory_chat">Regulatory Insights</MenuNavLink>
          <MenuNavLink to="/ai-catalyst/oapp_docs_chat">Ospree Get Started</MenuNavLink>
        </YStack>
      </YStack>
    </MenuDetailedWrapper>
  )
}

export default AiCatalystSidebar
